import type { QueryClient } from "@tanstack/react-query";
import type { RouteObject } from "react-router-dom";

import { MainLayout } from "@/components/organisms/Layout/MainLayout";
import { routePaths } from "@/config/route-paths";
import { RequireRole } from "@/features/auth";
import { handleDynamicImportError } from "@/lib/react-router";
import { convert } from "@/lib/react-router-convert";

export const PlaceholderManagementRoutes: (
  queryClient: QueryClient
) => RouteObject[] = (queryClient: QueryClient) => [
  {
    element: <MainLayout isExpand />,
    children: [
      {
        // 全テナント共通の設定。テナントに属さない運営者の世界に置く
        element: <RequireRole allow={["host"]} />,
        children: [
          {
            path: routePaths.admin.placeholders.path,
            lazy: () =>
              import("./placeholder-list-route")
                .then((m) => ({ default: m.PlaceholderListRoute }))
                .then(convert(queryClient))
                .catch((error) =>
                  handleDynamicImportError({
                    componentName:
                      "placeholder-management/routes/placeholder-list-route",
                    error,
                  })
                ),
          },
        ],
      },
    ],
  },
];
